import { CLOUD_ERROR_CODES, type CloudErrorCode } from "@shudian/contracts";

const ERROR_MESSAGES: Record<CloudErrorCode, string> = {
  [CLOUD_ERROR_CODES.INVALID_REQUEST]: "请求格式不合法",
  [CLOUD_ERROR_CODES.INTERNAL_ERROR]: "服务暂时不可用，请稍后重试",
  [CLOUD_ERROR_CODES.RATE_LIMITED]: "请求过于频繁，请稍后重试",
  [CLOUD_ERROR_CODES.AUTH_REQUIRED]: "需要登录",
  [CLOUD_ERROR_CODES.ADMIN_AUTH_REQUIRED]: "需要管理员登录",
  [CLOUD_ERROR_CODES.ADMIN_PERMISSION_REQUIRED]: "管理员权限不足",
  [CLOUD_ERROR_CODES.ENTITLEMENT_REQUIRED]: "缺少所需授权",
  [CLOUD_ERROR_CODES.INVALID_CREDENTIALS]: "邮箱或密码错误",
  [CLOUD_ERROR_CODES.INVALID_REFRESH_TOKEN]: "登录态已失效，请重新登录",
  [CLOUD_ERROR_CODES.INVALID_ADMIN_CREDENTIALS]: "邮箱或密码错误",

  [CLOUD_ERROR_CODES.TENANT_NOT_FOUND]: "用户不存在",
  [CLOUD_ERROR_CODES.TENANT_ALREADY_EXISTS]: "用户 ID 已存在",
  [CLOUD_ERROR_CODES.INVALID_TENANT_ID]: "用户 ID 格式不合法",
  [CLOUD_ERROR_CODES.INVALID_TENANT_NAME]: "用户名称不合法",
  [CLOUD_ERROR_CODES.INVALID_TENANT_OWNER_EMAIL]: "登录邮箱不合法",
  [CLOUD_ERROR_CODES.INVALID_TENANT_OWNER_NAME]: "联系人姓名不合法",
  [CLOUD_ERROR_CODES.INVALID_TENANT_OWNER_PASSWORD]: "初始密码至少 8 位",
  [CLOUD_ERROR_CODES.INVALID_TENANT_OWNER_PASSWORD_CONFIRMATION]: "两次输入的密码不一致",
  [CLOUD_ERROR_CODES.USER_ALREADY_EXISTS]: "登录账号已存在",
  [CLOUD_ERROR_CODES.USER_NOT_FOUND]: "登录账号不存在",
  [CLOUD_ERROR_CODES.USER_NOT_IN_TENANT]: "登录账号不属于当前账号主体",
  [CLOUD_ERROR_CODES.INVALID_USER_EMAIL]: "登录邮箱不合法",
  [CLOUD_ERROR_CODES.INVALID_USER_NAME]: "联系人姓名不合法",
  [CLOUD_ERROR_CODES.INVALID_USER_PASSWORD]: "登录密码至少 8 位",
  [CLOUD_ERROR_CODES.INVALID_USER_ROLE]: "账号角色不合法",
  [CLOUD_ERROR_CODES.INVALID_USER_STATUS]: "账号状态不合法",
  [CLOUD_ERROR_CODES.INVALID_LICENSE_PLAN]: "授权套餐不合法",
  [CLOUD_ERROR_CODES.INVALID_LICENSE_STATUS]: "授权状态不合法",
  [CLOUD_ERROR_CODES.INVALID_LICENSE_EXPIRES_AT]: "授权到期时间不合法",
  [CLOUD_ERROR_CODES.INVALID_DEVICE_LIMIT]: "设备数上限不合法",
  [CLOUD_ERROR_CODES.INVALID_ENTITLEMENTS]: "授权能力列表不合法",
  [CLOUD_ERROR_CODES.LICENSE_INACTIVE]: "授权已停用或已过期",

  [CLOUD_ERROR_CODES.DEVICE_LIMIT_EXCEEDED]: "已达设备数上限",
  [CLOUD_ERROR_CODES.DEVICE_REVOKED]: "设备已吊销",
  [CLOUD_ERROR_CODES.DEVICE_NOT_ACTIVE]: "设备未激活",
  [CLOUD_ERROR_CODES.DEVICE_NOT_FOUND]: "设备不存在",

  [CLOUD_ERROR_CODES.INVALID_USAGE_TYPE]: "用量类型不合法",
  [CLOUD_ERROR_CODES.INVALID_USAGE_QUANTITY]: "用量数量不合法",
  [CLOUD_ERROR_CODES.QUOTA_EXCEEDED]: "已超出额度",
  [CLOUD_ERROR_CODES.RESERVATION_NOT_FOUND]: "预留单不存在",
  [CLOUD_ERROR_CODES.RESERVATION_NOT_ACTIVE]: "预留单已结束",
  [CLOUD_ERROR_CODES.COMMIT_EXCEEDS_RESERVATION]: "提交量超出预留",

  [CLOUD_ERROR_CODES.BILLING_PROVIDER_DISABLED]: "支付服务未启用",
  [CLOUD_ERROR_CODES.INVALID_BILLING_WEBHOOK_SIGNATURE]: "支付回调签名不合法",
  [CLOUD_ERROR_CODES.BILLING_ORDER_NOT_FOUND]: "支付订单不存在",
  [CLOUD_ERROR_CODES.BILLING_PLAN_NOT_FOUND]: "请先配置至少一个可购买套餐",
  [CLOUD_ERROR_CODES.INVALID_BILLING_SETTINGS]: "支付设置不完整",
  [CLOUD_ERROR_CODES.ALIPAY_QR_CODE_CREATE_FAILED]: "支付宝二维码创建失败，请稍后重试",

  [CLOUD_ERROR_CODES.INVALID_RULE_BUNDLE_VERSION]: "规则包版本号不合法",
  [CLOUD_ERROR_CODES.INVALID_RULE_BUNDLE_EXPIRES_AT]: "规则包过期时间不合法",
  [CLOUD_ERROR_CODES.RULE_BUNDLE_EXPIRED]: "规则包已过期",
  [CLOUD_ERROR_CODES.INVALID_RULE_BUNDLE_PAYLOAD]: "规则包内容不合法",
  [CLOUD_ERROR_CODES.INVALID_RULE_BUNDLE_PLATFORM]: "规则包平台不合法",
  [CLOUD_ERROR_CODES.RULE_BUNDLE_UNAVAILABLE]: "暂无可用规则包，请先发布规则包",

  [CLOUD_ERROR_CODES.DESKTOP_UPDATE_RELEASE_NOT_FOUND]: "桌面更新发布记录不存在",
  [CLOUD_ERROR_CODES.DESKTOP_UPDATE_ARTIFACT_NOT_FOUND]: "桌面更新文件不存在",
  [CLOUD_ERROR_CODES.INVALID_DESKTOP_UPDATE_SIGNATURE]: "桌面更新签名文件不合法",

  [CLOUD_ERROR_CODES.SYNC_DEVICE_NOT_TRUSTED]: "同步设备未受信任",
  [CLOUD_ERROR_CODES.SYNC_DEVICE_REVOKED]: "同步设备已吊销",
  [CLOUD_ERROR_CODES.SYNC_RECORD_REJECTED]: "同步数据包含不允许上传的敏感内容",
  [CLOUD_ERROR_CODES.SYNC_BLOB_NOT_FOUND]: "同步密文数据不存在",
  [CLOUD_ERROR_CODES.INVALID_SYNC_PAYLOAD]: "同步请求内容不合法",
  [CLOUD_ERROR_CODES.SYNC_AUTH_FAILED]: "同步鉴权失败或账号主体不一致",
  [CLOUD_ERROR_CODES.SYNC_DEVICE_UNAUTHORIZED]: "当前同步设备未被信任或已吊销",
  [CLOUD_ERROR_CODES.SYNC_DATA_INTEGRITY_VIOLATION]: "同步数据归属异常，已阻止读取"
};

export function describeError(code: string | undefined | null): string {
  if (!code) return "未知错误";
  if ((Object.values(CLOUD_ERROR_CODES) as string[]).includes(code)) {
    return ERROR_MESSAGES[code as CloudErrorCode];
  }
  return "操作失败，请稍后重试";
}

export class CloudApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(code: string, status: number) {
    super(describeError(code));
    this.code = code;
    this.status = status;
  }
}
